// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_Zsi","right":"styles_right__2abI3"};